import type { AiAppCenterModule } from '../types'

/** 玄机平台独立应用；模块标识和首页与 system_module.adminCard 配置一致。 */
export const xuanjiModule: AiAppCenterModule = {
  key: 'xuanji',
  label: '玄机阁平台',
  desc: '机构与师傅、服务订单、履约结算、文化内容及专业工具管理',
  path: '/xuanji',
  homePath: '/xuanji/dashboard',
  menuPaths: ['/xuanji'],
  icon: 'ep:compass',
  color: '#722ed1',
  aliases: ['玄机平台管理', '玄机平台', '玄机阁']
}
